let hideTimer: number | undefined;

export function showToast(message: string, isError = false): void {
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = message;
  el.classList.toggle('error', isError);
  el.hidden = false;
  window.clearTimeout(hideTimer);
  hideTimer = window.setTimeout(() => {
    el.hidden = true;
  }, 4000);
}
